type Props = { x?: number; y?: number }

export const OrangeDot: React.FC<Props> = ({ x, y }) => {
  return (
    <svg x={x} y={y} width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="6" cy="6" r="5.5" fill="#F97700" stroke="white" />
    </svg>
  )
}
